export const email = "info@dr-cad.ir";
export const appName = "ORDA";
export const orgName = "Dr Cad";
export const siteURL = "orda.dr-cad.ir";
